"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Image.css");
var _Default_image = _interopRequireDefault(require("../assets/Default_image.png"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Image.js
* Description : Ce fichier contient la définition du composant Image 
*               Ce composant affiche une image en s'adaptant à la taille de l'écran
* Date de création : 8 octobre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */
// None

/* Hook */

/**
* Image : ce composant affiche une image en s'adaptant à la taille de l'écran
*         si aucune URL n'est fournie, c'est une image par défaut qui est affichée
*
* Type : composant 
*
* Parametres : 
*  - url -- URL de l'image
*/function Image(_ref) {
  var url = _ref.url;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex-row justify-center",
    children: url !== null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: url,
      alt: "photo_item",
      className: screenWidth > 650 ? 'image' : 'image-ss'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _Default_image["default"],
      alt: "Default_image",
      className: screenWidth > 650 ? 'image' : 'image-ss'
    })
  });
}
var _default = exports["default"] = Image;